import { Action } from '@ngrx/store';

export enum ActionTypes {
  CLEAR_STATE = '[Global] Clear State'
}

export class ClearStateAction implements Action {
  readonly type = ActionTypes.CLEAR_STATE;
}

export type GlobalActions = ClearStateAction;
